<ion-content class="ion-padding">
  <curbnturf-recover [inModal]="true"></curbnturf-recover>
</ion-content>
